import lodash from "lodash";

const CURRENCY_SYMBOL = "€";

export const getFormattedRoundedPrice = (
	priceValue,
	currencySymbol = CURRENCY_SYMBOL
) => {
	return currencySymbol + getRoundedPrice(priceValue);
};

export const getFormattedPrice = (
	priceValue,
	currencySymbol = CURRENCY_SYMBOL
) => {
	return `${currencySymbol}${priceValue}`;
};

export const getRoundedPrice = (priceValue) => {
	return priceValue % 1 != 0 ? priceValue.toFixed(2) : priceValue.toFixed(0);
};

export const getDiscount = (priceOffer) => {
	const discount = priceOffer.promotionalValueTexts
		? priceOffer.promotionalValueTexts[0]
		: null;
	return discount
		? `${getFormattedRoundedPrice(discount.item2)} ${discount.item1}`
		: null;
};

export const getDiscountValue = (priceOffer) => {
	const discount = priceOffer.promotionalValueTexts
		? priceOffer.promotionalValueTexts[0]
		: null;
	return discount ? discount.item2 : null;
};

export const getInstallmentsDiscountValue = (
	priceOffer,
	promptPaymentValue
) => {
	const { campaignValue, campaignMonthlyValue, months } = priceOffer;
	const discountValue =
		promptPaymentValue - (campaignValue + campaignMonthlyValue * months);
	return discountValue > 0 ? discountValue : null;
};

export const getInstallmentsDiscount = (
	priceOffer,
	promptPaymentValue,
	resource
) => {
	const value = getInstallmentsDiscountValue(priceOffer, promptPaymentValue);
	return value ? `${getFormattedRoundedPrice(value)} ${resource}` : null;
};

export const getMinPriceOffer = (purchaseMode, priceOffers) => {
	const purchaseModeGroup = getPurchaseModeGroup(purchaseMode);
	return getMinPriceOfferByPurchaseModeGroup(purchaseModeGroup, priceOffers);
};

export const getPriceOffersByIds = (
	entityObj,
	priceOfferIdsArray,
	filter = null
) => {
	return priceOfferIdsArray.map((id, i) => entityObj[id]);
};
